const languageMap = {
  lt: "lt",
  lv: "lv",
  ee: "et",
  ru: "ru",
  en: "en",
};
export default languageMap;
